import React, { useState, useContext, useEffect } from "react";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import FilterMenu from "./FilterMenu";
import APopover from "../../common/a-popover";
import { getActiveProcessTagUrl, getAllActiveRoleUrl, getUpdatedFilterRequest } from "./constant";
import { dropdownMapping } from "../../common/utils/methods/commonMethods/utilityMethod";
import SearchInput from "./SearchInput";

const Filters = ({
  crossInputHandler,
  searchInputValueHandler,
  isLoading,
  paymentCategoryDropdown,
  globalFilter,
  setGlobalFilter,
  getPaymentModeListing,
}) => {
  // const { setGlobalFilter } = useContext(ReceiptListContext);
   const [filterCount, setFilterCount] = useState(0);
   const [processTagDropdown,setProcessTagDropdown]= useState([]);
   const [rolesDropdown,setRolesDropdown] = useState([])
  

 const applyFilters = (newFilters) => {
  const updatedRequest= getUpdatedFilterRequest({...globalFilter,...newFilters})
    setGlobalFilter((prev) => ({ ...prev, ...newFilters}));
    getPaymentModeListing(updatedRequest)
  };

useEffect(()=>{
  const getAllDropdowns= async()=>{
    const dropdowns= await Promise.all([
      dropdownMapping(getActiveProcessTagUrl,'tagTypeDispValue','id'),
      dropdownMapping(getAllActiveRoleUrl,'roleName','id')
    ])
    console.log(dropdowns)
    setProcessTagDropdown(dropdowns[0]);
    setRolesDropdown(dropdowns[1])
  }
    getAllDropdowns();
  },[])

  return (
    // <div className="d-flex flex-column">
    <div className="d-flex">
      <SearchInput
        searchInputValueHandler={searchInputValueHandler}
        onCancel={crossInputHandler}
        errorMsg={false}
        isLoading={isLoading}
        globalFilter={globalFilter}
        setGlobalFilter ={setGlobalFilter}
      />

      <div className="d-flex justify-content-end">
        <APopover
          buttonComponent={(onClick, styles) => (
            <AButton
              className="tiny-semi-bold color-dark"
              disabled={false}
              onClick={onClick}
              updatedStyle={{
                minWidth: "61px",
                ...(filterCount > 0
                  ? {
                      border: "1px solid #00B0F5",
                      color: "#00B0F5",
                    }
                  : styles),
              }}
            >
              Filters {filterCount > 0 && <>( {filterCount} )</>}
            </AButton>
          )}
          menuComponent={(closeForm) => (
            <>
              <FilterMenu
                  paymentCategoryDropdown={paymentCategoryDropdown}
                  processTagDropdown={processTagDropdown}
                  rolesDropdown={rolesDropdown}
                 filterCount={filterCount}
                 setFilterCount={setFilterCount}
                closeForm={closeForm}
                globalFilter={globalFilter}
                 applyFilters={applyFilters}
              />
            </>
          )}
          maxHeight={"calc(100vh - 180px)"}
        />
      </div>
    </div>
    // </div>
  );
};

export default Filters;
